import { Component, EventEmitter, Input, Output } from '@angular/core';

import { INavbarTabContentItem } from './navbar-tab-content-item.types';

@Component({
  selector: 'nx-navbar-tab-content-item',
  templateUrl: './navbar-tab-content-item.component.html',
  styleUrls: ['./navbar-tab-content-item.component.scss'],
})
export class NavbarTabContentItemComponent implements INavbarTabContentItem {
  // PROPERTIES
  @Input() hasDropdown: INavbarTabContentItem['hasDropdown'] = false;
  @Input() contentHref!: INavbarTabContentItem['contentHref'];
  @Input() link?: INavbarTabContentItem['link'];
  @Input() dropdown?: INavbarTabContentItem['dropdown'];
  @Input() isDropdownActive!: INavbarTabContentItem['isDropdownActive'];
  @Output()
  isDropdownActiveChange: INavbarTabContentItem['isDropdownActiveChange'] =
    new EventEmitter();

  // METHODS
  toggleDropdown(): void {
    this.isDropdownActiveChange.emit(!this.isDropdownActive);
  }
}
